import { ContextStore } from 'bernie-core';
import { Logger } from 'bernie-logger';
import { bffFetch, Headers } from './bff-fetch';

export class HotelSearchApiSource {
  private host: string;
  private logger: Logger;
  private forwardedHeaders: Headers;

  constructor(host = '', logger, forwardedHeaders: Headers = {}) {
    this.host = host;
    this.logger = logger;
    this.forwardedHeaders = forwardedHeaders;
  }

  public fetch(context: ContextStore, criteria: any) {
    return bffFetch(this.host, 'hotels', context, criteria, this.logger, this.forwardedHeaders);
  }

  public fetchAlternateDates(context: ContextStore, api: string) {
    return bffFetch(this.host, api, context, {}, this.logger, this.forwardedHeaders);
  }
}
